// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//const URL = 'https://www.chulalifedi.com:6100/api/v1/lifeDi';
const URL = 'https://www.chulalifedi.com/api/v1/lifeDi';

// Default key
const KEY = 'WEW9ZUB64GDWD7Y4HN7CEP9YJ49L8LKZ7ZJT6Q2AELUTUSQ';

// ### Vimeo Access ######
const VIMEO_CLIENT_ID = '5789fad4e57b83a5c5fb29ee8ee9ffdf0d5c1772';
const VIMEO_CLIENT_SECRET = 'cW0vuK/6/PD0/dFMmOhvFDnfVIGQKaqhX84Mv8bXqhBlVwbmugUd2yBpbXx3l7ZFSnVjpJ1cE2f+lC78vSrZ0RutG/mXMuuhFk8YP1MDNndzj0Q55uW8rJTwbOeAJ9Pr';
const VIMEO_ACCESS_TOKEN = '17dbfcd0672dc42603e055f4ab8f837d';
const VIMEO_API_URL = 'https://api.vimeo.com/me/videos';

// Google Analytics
const GA_TRACKING_ID = 'G-5NH50XP7LL';


export const environment = {
  production: false,
  URL,
  KEY,
  VIMEO_CLIENT_ID,
  VIMEO_CLIENT_SECRET,
  VIMEO_ACCESS_TOKEN,
  VIMEO_API_URL,
  GA_TRACKING_ID
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
